module.exports = __webpack_public_path__ + "media/images/pic/labels/b1_1b-5edca66336c0d78c3b9366067c5679a6.png";